/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class ProcessEventConfigurationService extends services.DataService<Wars.Domain.Model.ProcessEventConfiguration> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService, private $http: angular.IHttpService) {
            super(injectedBreeze, $q);
        }

        public getProcessEventConfigurations(processId?: string): angular.IPromise<Wars.Domain.Model.ProcessEventConfiguration[]> {
            const expand = "myInitiateSecurityMatrix, " +
                "myViewSecurityMatrix, " +
                "myProcessAction, " +
                "myProcessConfiguration.myProcessType," +
                "documentConfiguration.canDownloadSecureDocumentSecurityMatrix, " +
                "documentConfiguration.canSecureDocumentSecurityMatrix, " +
                "documentConfiguration.myAvailableDocumentTypes.mySystemCode";

            const query = this.breezeModule.EntityQuery
                .from("ProcessEventConfigurations")
                .where('processConfiguration_id', '==', processId)
                .expand(expand)
                .orderBy("name");

            return this.executeQuery(query);
        }

        public createProcessEventConfiguration(): Wars.Domain.Model.ProcessEventConfiguration {
            return <Wars.Domain.Model.ProcessEventConfiguration>(this.createNewEntity("ProcessEventConfiguration"));
        }

        public createProcessEventConfigurationReso(): Wars.Domain.Model.ManageProcessEventConfigReso {
            return <Wars.Domain.Model.ManageProcessEventConfigReso>(this.createNewEntity("ManageProcessEventConfigReso"));
        }
    }
}

warsApp.registerService('ProcessEventConfigurationService', ['breeze', '$q', '$http']);